import React, { useEffect, useState } from 'react';
import { ICarPartData } from '../../../models/car-parts.model';
import './PartItemDetails.scss';
import { useTranslation } from 'react-i18next';
import { use } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { set } from 'lodash';

type Props = {
  carPart: ICarPartData;
}

const PartItemDetails: React.FC<Props> = (props) => {
  const carPart = props.carPart;
  const { t } = useTranslation();

  const [pdf, setPdf] = useState<string[]>([]);


  useEffect(() => {
    if (props.carPart?.images) {
      const pdfFiles = props.carPart.images.filter((image) => image.toLowerCase().endsWith('.pdf'));

      if (pdfFiles.length > 0) {
        setPdf(pdfFiles);
      }
    }
  }, [props.carPart]);

  return (

    <div className="car-part-details-wrapper">
      <div className="car-detail__header">
        <div className="car-detail__header__article">
          <span>{t('_reference')}</span> :
          {` ${carPart.data_supplier_reference_original}`}
        </div>
        <h5 className="car-detail__header__title">{`${carPart.data_supplier.name} ${carPart.data_supplier_reference_original}`}</h5>
        <div className="car-detail__header__category">
          {`${carPart.subcategory?.name ? carPart.subcategory?.name : '-'}`}
        </div>
        <div className="car-detail__header__set">
          {carPart.quantity && Number(carPart.quantity) ? `${carPart.quantity} ${t('_items_in_pack')}, ` : ''}
        </div>
      </div>
      <div className="car-detail__content">
        {
          carPart.characteristics.map((characteristic, index) => (
            <div className="content-item" key={index}>
              <p className="label">{t(characteristic.name)}: </p>
              <p className="value">{characteristic.name === '_reference_commerciale' ? <span className="commercial-ref-value">{characteristic.value}</span> : characteristic.value} {characteristic.unit ? characteristic.unit : ''}</p>
            </div>
          ))
        }
        {
          pdf.length > 0 ? (
            <div className="content-item">
              <p className="label">{t('_pdf_items')}: </p>

              <div className="pdf-files">
                {
                  pdf.map((pdfFile, index) => (


                    <a href={pdfFile} key={index} target="_blank" rel="noreferrer"><FontAwesomeIcon className="pdf-icon" icon={faFilePdf} /></a>


                  ))

                }
              </div>

            </div>
          ) : null
        }
      </div>
    </div>
  );
};

PartItemDetails.displayName = 'PartItemDetails';


export default PartItemDetails;